<div>
  <app-notifications></app-notifications>
</div>